import React from 'react';
import DataResource from '../../../../common/v4/DataResource'
import Panel from '../../../../common/layout/Panel'

const AccessAreas = (props) => {
    const data = {
        url: `/admin/access/areas`,
        data: {
            data: [],
            metadata: []
        },
        onclick: 'link',
        link: `/admin/access/areas/{id}`,
        metadata: [
            {
                label: 'id',
                source: 'id',
                type: 'primary',
                editable: false,
                visible: false
            },
            {
                label: 'Name',
                source: 'name',
                type: 'text',
                editable: true,
                default: '',
                placeholder: 'Area Name'
            },
            {
                label: 'Description',
                source: 'description',
                type: 'text',
                editable: true,
                default: '',
                placeholder: 'Area Description'
            },
            {
                label: 'Rights Count',
                source: 'rights_count',
                type: 'number',
                editable: false,
                visible: true
            },
            {
                label: 'Created',
                source: 'created_at',
                type: 'datetime',
                editable: false,
                visible: true
            },
            {
                label: 'Updated',
                source: 'updated_at',
                type: 'datetime',
                editable: false,
                visible: true
            },
            {
                label: 'Delete',
                type: 'delete'
            }
        ]
    }

    return (   
        <Panel title="Access Areas">
            <DataResource
                addButtonText="Create Access Area" 
                addButtonLink="/admin/access/areas/create"
                data={data}
                {...props} 
            />
        </Panel>
    )
}

export default AccessAreas; 